import React from 'react';

const axios = require('axios').default;

class ErrorBoundary extends React.Component {
    constructor(props: any) {
        super(props);
        this.state = { hasError: false };
    }
  
    static getDerivedStateFromError(error: any) {
        return { hasError: true };
    }
  
    componentDidCatch(error: any, errorInfo: any) {
        console.log(error);
        console.log(errorInfo);

        let logindata = localStorage.getItem('logindata');
        if (logindata != null) {
            let login = JSON.parse(logindata);
            if (login.jwt != undefined) {
                axios.put('/api/logging', {
                    level: 'http',
                    message: error + " | " + window.location.href,
                }, {
                    headers: {
                        'Content-Type': 'application/json',
                        'UserAuthorization': 'Bearer ' + login.jwt
                    }
                });
            }
        }
    }

    render() {
        if ((this.state as any).hasError) {
            return <div>
                <h1>Something went wrong.</h1>
                <p>A report has been sent to the server.</p>
                <hr/>
                <p>Try refreshing the page.</p>
            </div>;
        }
  
        return (this.props as any).children; 
    }
}

export default ErrorBoundary;